import { createIcon as n } from "../createIcon.js";
const t = {
  name: "MinusIcon",
  height: 512,
  width: 448,
  svgPath: "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z",
  yOffset: 0,
  xOffset: 0
}, o = n(t);
export {
  o as MinusIcon,
  t as MinusIconConfig,
  o as default
};
